import {
  FC,
  useMemo,
  useCallback,
  useState,
  useEffect,
  ReactElement,
} from "react";
import {useHistory, useLocation, useParams, useRouteMatch} from "react-router-dom";
import styled, { useTheme, ThemeProvider, css } from "styled-components";
import { useTranslation } from "react-i18next";
import {
  LayoutConst,
  modalControllerActions,
  modalControllerSelector,
  ModalControllerSlice,
  SHARED_MODALS,
  useModal,
} from "core";
import {
  AppTester,
  getContextFromAppName,
} from "supporting";
import { ApplicationShared } from "core";
import { ApplicationTheme } from "shared/themes";
import { useAuth } from "core/hooks/auth/useAuth";
import { NavBar } from "shared/components/__FOX__/NAV/src";
import { CreateLinkTo, LinkTo } from "shared/constants/linkTo";
import WidgetLogin from "./WidgetLogin";
import MobileBottomBar from "./MobileBottomBar";
import { useSelector, useDispatch } from "react-redux";
import {
  RectangularButtonFilled,
  RectangularButtonHollow,
} from "../components/buttons";
import {
  FlexBox,
  FInter,
  useIsMobile,
  useBreakpoint,
  BLangSwitcher,
  NavbarButtonFilled,
  Colors,
  useToasts} from "@brg/ui";
import { AbsoluteWrapper } from "../components/navbar-elements/navbar-create";
import PreviewIconOpen from "../assets/32/PreviewIconOpen";
import PreviewIconClosed from "../assets/32/PreviewIconClosed";
import { ModalMenuContextMobileNew } from "./ModalMenuContextMobileNew";
import { NeutralLink } from "shared/components/link/styles";
import {
  ANCHOR_ONLINES_LINK,
  ApplyBtn,
} from "shared/components/Footer/OnlinesFooter";
import { BLanguageSelectionComponentOnlines } from "core/components/BLanguageSelectionComponentOnlines";
import { SaveUserLang } from "shared/components/__ADDONS__/__LANG__/Utils/GetUserLang";
import { setAppLang } from "shared/components/__ADDONS__/__LANG__/Slice";
import useQueryState from "shared/hooks/useQueryState";
import { OpenDayButton } from "./DeziiignNavbar";
import { useOnlinesParam } from "shared/hooks/OnlinesParamFilter";
import { useContextsTabs } from "shared/hooks/useContextsTabs";
import { MobileMenuStateAction } from "shared/reducers/mobileMenuOpen";
import { bProfile, ProfileRole, useProfile } from "@brg/auth";
import { TagsSelector } from "../reducers/Tags";
import { DropdownWrapper } from "./HSEDeziiignNavbar";
import { DropdownWithExternalsLinks } from "./components/contextTabsItems";
import { ORGANIZATION_LIST } from "shared/hooks/useGetCurrentTeam";
import { GeoTagModalSelector } from "shared/reducers/geoTagsModal";
import NotificationsController from "../components/NotificationsController/NotificationsController";
import { MainSearchButton } from "shared/components/MainSearchController/MainSearchButton";
import TeamInfo, { PhoneText } from "../components/TeamInfo/TeamInfo";
import { CourseInfoListController } from "shared/components/CourseInfoListController/CourseInfoListController";
import useExternalOrganization from "../pages/exploreHseContextsNew/useExternalOrganization";
import {ModerationType} from "../pages/teams/const/ModerationTypes";
import { AgreeOrClose, IconStates } from "./components/AgreeOrClose";
import { MobileSaveBlock } from "./components/MobileSaveBlock";
import FeedButton from "../components/NotificationsController/FeedButton";
import { setIsOpen } from "shared/reducers/OpenModal";
import { useGetLogo } from "shared/components/navigationSystem/useGetLogo";
import {getShouldDisplaySearch} from "../helpers/getShouldDisplaySearch";
import { API, CardAPI, Endpoints, Team } from "@brg/api";
import { Input } from "@brg/input";
import { ProjectEditPageGridInput } from "_deziiign/books/pages/BookEdit/styles";
import ChannelButton from "shared/components/NotificationsController/ChannelButton";
import { NavbarSearchActions } from "shared/reducers/NavbarSearch";
import GameButton from "shared/components/NotificationsController/GameButton";
import { useChannelsContext } from "shared/contexts/ChannelsContext";
import { hasDefaultChannel, hasPersonalChannel } from "shared/helpers/teamsStatus";
import { useGetFeedInfo } from "shared/hooks/api/useGetFeedInfo";
import { HsePolicies } from "shared/constants/HsePolicies";

export const DropdowCreateProjectnWrapper = styled(FlexBox)`
  white-space: nowrap;
`;

const CustomDropdown = styled(Input.Dropdown)`
  .brg-input__control {
    height: 20px !important;
    width: ${p => p.lang === 'en' ? '219px' : '250px'} !important;
    color: #FEFEFE !important;
    background-color: #151514 !important;
    border: 1px solid #444 !important;
    box-shadow: none !important;
    padding-left: 8px;
    cursor: pointer;
  }
    
  .brg-input__value-container{
    height: 100% !important;
    margin-top: -3px;
  }

  .brg-input__control:hover svg {
    fill:  #FEFEFE !important;
    color: #FEFEFE !important;
  }

  .brg-input__placeholder{
    color: #FEFEFE !important;
    font-weight: 600;
    white-space: nowrap;
  },

  .brg-input__placeholder:hover{
    color: #FEFEFE !important;
  }
  .brg-input__control:hover .brg-input__placeholder {
    color: #FEFEFE !important;
  }

 .brg-input__menu {
    width: 250px;
    border-radius: 3px;
    margin-top: 8px;
  }

  .brg-input__menu-list {
    padding: 0;
  }

  .brg-input__option {
    color: #ddd !important;
    padding: 8px 12px;
  }

  .brg-input__indicator {
    width: auto;
    height: 34px;
  }

  .brg-input__dropdown-indicator svg path{
    fill: #fefefe !important;
  }

.brg-input__dropdown-indicator{
    opacity: 1;
    margin-right: 14px;
    padding: 8px 8px 8px 10px;
  }

  .brg-input__control:hover svg { fill: #FEFEFE !important; }

  @media (max-width: ${LayoutConst.screen.l}px) {
    .brg-input__control {
      margin: 0 17px;
    }
      
    .brg-input__menu{
      margin-left: 17px;
    }
  }
`;

export const Burger = styled(FlexBox)`
  height: 40px;
  align-items: center;
  opacity: 1;
  transition: all 0.2s;

  &:hover {
    opacity: 1;
  }
  ${FlexBox} {
    @media (max-width: 568px) {
      margin-right: 6px; /* важно, изменения для всего сайта */
    }
  }
`;

export const NavbarOuter = styled(FlexBox)<{
  shifted?: boolean;
  isAgeytomesh?: boolean;
  logoLength?: number;
}>`
  max-width: 300px;
  position: relative;
  left: ${(p) => (p?.shifted ? `-${p?.logoLength}px` : 0)};
  transition: all 500ms;
`;

export const LogoName = styled(FlexBox)<{ isGeo?: boolean; isDafes?: boolean }>`
  font-family: Inter, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: ${({ isDafes }) => isDafes ? '17px' : '24px'};
  line-height: ${({ isDafes }) => isDafes ? '22px' : '40px'};
  color: ${(p) =>
    p?.isDafes ? "#151514" : p.theme.navigationBar.logoName};
  position: relative;
  top: -1px;

  ${(p) =>
    p?.isGeo
      ? css`
          font-size: 17px;
          line-height: 22px;
          top: 1px;
        `
      : null};
`;

const RightSection = styled.div<{ isDafes?: boolean }>`
  display: flex;
  align-items: center;
`;

const CreateButton = styled.div<{ hide?: boolean, isMedia?: boolean, isKiiids?: boolean }>`
  display: ${({ hide }) => (hide ? "none" : "flex")};
  align-items: center;
  justify-content: center;
  padding: 4px 16px;
  background: ${({ theme, isKiiids }) => isKiiids? '#94209E' : theme.navigationBar.btns.create.bg};
  border-radius: ${({isMedia, isKiiids}) => isMedia || isKiiids ? '8px' : '3px'};
  font-family: Inter, sans-serif;
  font-style: normal;
  height: 36px;
  font-weight: 700;
  font-size: 15px;
  line-height: 20px;
  color: ${({ theme }) => theme.navigationBar.btns.create.color};
  margin-right: 16px;
  // min-width: 132px;
  min-width: auto;
  padding: 8px 24px;
  max-width: min-content;
  white-space: nowrap;

  @media (max-width: ${LayoutConst.screen.m_1024}px) {
    height: ${({isKiiids}) => isKiiids? 40 : 32}px;
  }

  // @media (max-width: ${LayoutConst.screen.sm}px) {
  //   height: 30px;
  //   margin-right: 6px;
  //   min-width: 84px;
  //   padding: 6px 15px;
  //   max-width: 84px;
  // }
`;

const ExitButton = styled(RectangularButtonHollow)<{ isTeamEdit?: boolean }>`
  margin-right: 14px;
  // width: 87px !important;
  // min-width: 87px !important;
  width: auto !important;
  min-width: auto !important;
  height: 36px !important;
  margin-left: 16px;
  margin-right: 0;
  font-weight: 600 !important;
  padding-left: 24px;
  padding-right: 24px;

  @media (max-width: ${LayoutConst.screen.sm}px) {
    height: ${({ isTeamEdit }) => (isTeamEdit ? "28px" : "26px")} !important;
    font-size: 13px;
    line-height: 16px;
    padding-left: 16px;
    padding-right: 16px;
  }

`;

const SaveButton = styled(NavbarButtonFilled)`
  width: auto;
  min-width: auto;
  max-width: none;
  line-height: 16px;
  height: 36px !important;
  padding: 4px 24px;
  min-height: 24px;
  margin-right: 6px;
  font-weight: 600 !important;
  letter-spacing: normal;
`;

const AgreeButtonWrapper = styled.button<{ disabled?: boolean, isPreview?: boolean }>`
    margin-bottom: 6px;
    cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
    pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
    user-select: ${({ disabled }) => (disabled ? "none" : "auto")};
    outline: none;
    border: none;
    background: none;
    padding: 0;
    ${({isPreview}) =>
      isPreview
        ? css`
            margin-right: 16px;
          `
        : null};

  svg {
    path {
      fill: ${Colors.galBlack47};
    }
  }

  &:hover {
    svg {
      path {
        fill: ${({ disabled }) =>
          disabled ? Colors.galBlack47 : Colors.galBlack100};
      }
    }
  }
  &:focus {
    outline: none;
  }
`;

const ProjectSaveButton = styled(NavbarButtonFilled)`
  // width: 132px;
  width: auto;
  min-width: auto;
  height: 36px !important;
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.02em;
  padding-left: 24px;
  padding-right: 24px;

  @media (max-width: 568px) {
    // width: 102px;
    // min-width: 102px;
    width: auto;
    min-width: auto;
    height: 28px !important;
    min-height: 28px;
    font-weight: 600;
    font-size: 13px;
    line-height: 16px;
    padding-left: 16px;
    padding-right: 16px;
  }

  &:disabled {
    background-color: ${({ theme }) =>
      theme.projectEdit?.btns?.navbar?.disabled?.bg} !important;
    color: ${({ theme }) =>
      theme.projectEdit?.btns?.navbar?.disabled?.color} !important;
  }
`;

const IconWrapper = styled(FlexBox)`
  & svg {
    stroke-width: 0.2px;
  }
`


const NavBarWrapper = styled.div<any>`
  ${p => p.isKiiidsArt && 
    css`
      div#navbar {
        margin: 0 40px;
        @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
          margin: 0 22px 0 32px;
        }
        @media (max-width: ${LayoutConst.screen.l}px), (max-width: ${LayoutConst.screen.sm}px) {
          margin: 0 16px;
        }
      }
    `
  }
`

const LangSwitcherWrapper = styled(FlexBox)<any>`
  div.langitem-active {
    ${p => p.isKiiidsArt && 'color: #FEFEFE;'}
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    margin: 0 8px 0 0;
  }

  @media (max-width: ${LayoutConst.screen.s-1}px) {
    margin: 0 8px 0 0;
  }
`

type PropsT = {
  onLangSwitch?: () => void;
  onPrimaryClick?: () => void;
  onSecondaryClick?: () => void;
  primaryButtonEnabled?: boolean;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  onPreviewClick?: () => void;
  dropdown?: ReactElement;
  currentTheme?: any;
  mobileEditorOpen?: boolean;
  canSaveInDrafts?: boolean;
  toggleMobileEditor?: (val: boolean) => void;
  previewButtonVisible?: boolean;
  previewButtonEnabled?: boolean;
  primaryButtonVisible?: boolean;
  secondaryButtonVisible?: boolean;
  closeIconVisible?: boolean;
  canSaveLgText?: boolean;
  proTypeOptions?: any;
  navProTypeValue?: any;
  onProTypeChange: (opt: { label: string; value: string } | null) => void;
};

const DeziignNavBarMobile: FC<PropsT> = ({
  onLangSwitch,
  onPrimaryClick,
  onSecondaryClick,
  primaryButtonEnabled,
  previewButtonEnabled,
  primaryButtonVisible = true,
  secondaryButtonVisible = true,
  primaryButtonText,
  secondaryButtonText,
  onPreviewClick,
  mobileEditorOpen,
  toggleMobileEditor,
  canSaveInDrafts,
  previewButtonVisible,
  closeIconVisible = false,
  canSaveLgText,
  proTypeOptions,
  onProTypeChange
}) => {
  const theme = useTheme();
  const history = useHistory();
  const isBooksGallllery = AppTester.isBooksGallllery()
  const { emit, token } = useAuth();
  const location = useLocation();
  const toasts = useToasts();
  const {
    t,
    i18n,
    i18n: { language },
  } = useTranslation();
  const dispatch = useDispatch();
  const modal = useSelector(modalControllerSelector);
  const modalToggle = useModal();
  const modalIsOpen = useMemo(() => !!modal.name, [modal]);
  const { hide: hideModal } = useModal();
  const isPreview = useRouteMatch<{ id: string }>([
    "/preview/:id",
    "/books/book-preview/:id",
    "/books/preview/:id",
    "/book-preview/:id",
    "/team-preview/:id",
    "/team-longread-preview/:id",
  ]);
  const isProjectPreview = useRouteMatch<{ id: string }>(["/preview/:id"]);
  const isProjectOnlyEdit = useRouteMatch<{ id: string }>(["/edit/:id"]);
  const isTeamPreview = useRouteMatch<{ id: string }>("/team-preview/:id");
  const isTeamLgPreview = useRouteMatch<{ id: string }>(
    "/team-longread-preview/:id"
  );
  const isBookChapterPreview = !!useRouteMatch([
    "/books/preview/:id",
    "/book-preview",
  ]);
  const isProjectEdit = useRouteMatch<{ id: string }>([
    "/edit/:id",
    "/books/edit/:id",
  ]);
  const isBookEdit = useRouteMatch<{ id: string }>([
    "/books/book-edit/:id",
    "/book-edit/:id",
  ]);
  const isBooksEdit = useRouteMatch<{ id: string }>("/books/edit/:id");
  const isCompetitionEdit = !!useRouteMatch<{ id: string }>(
    "/competition-edit/:id"
  );
  const isProfileEdit = useRouteMatch<{ id: string }>("/designer/edit/:id");
  const isProfilePage = useRouteMatch<{ id: string }>("/designer");
  const isTeamEdit = !!useRouteMatch("/team-edit");
  const isBrnd = AppTester.isBrnd();
  const isMedia = AppTester.isMediiia();
  const isLectureMediiia = AppTester.isLectureMediiia();
  const isProDeziiign = AppTester.isProDeziiign();
  const isCGRave = AppTester.isCGRAVE();
  const isAdcrDafesNet = AppTester.isAdcrDafesNet();
  const isFashionDeziiign = AppTester.isFashionDeziiign();
  const isGreenAward = AppTester.isGreenAward();
  const isLPU = AppTester.isLPUDesign();
  const isHseSpace = AppTester.isHseSpace();
  const isSpacePro = AppTester.isContext('s-pro');
  const isProHSE = AppTester.isProHSE();
  const id = isPreview && isPreview?.params?.id;
  const isMobile = useIsMobile();
  const isTablet = useBreakpoint(1200);
  const is744 = useBreakpoint(LayoutConst.screen.s);
  const is430bp = useBreakpoint(470);
  const is568bp = useBreakpoint(LayoutConst.screen.sm);
  const is1200 = useBreakpoint(1200);
  const [{ lang, mainBookId }, setQueryParams] = useQueryState();
  const { initialTab, context: contextName } = useContextsTabs();

  const [navProTypeValue, setNavProTypeValue] = useState<{ label: string; value: string } | null>(null);

  const isDropdownEnabled = isProDeziiign || isProHSE || isSpacePro; 
  
  const onDropdownChange = (option: { label: string; value: string } | null) => {
    if (option) {
      setNavProTypeValue(option);
      history.push(CreateLinkTo.projectCreate(), { selectedType: option.value });
    }
  };

  const mainLogo = useGetLogo({})

  const [setUserParam] = useOnlinesParam();
  const onlinesUserParam = sessionStorage.getItem("userParam");

  const [, setVisibleModalMenuCategoriesMobile] = useState<boolean>(false);
  //@ts-ignore
  const isOpen = useSelector((state) => state.openModal.isOpen);

  const closePopup = useCallback(() => {
    dispatch(setIsOpen(false));
  }, [dispatch]);

  const onMobileProjectSaveClick = () => {
    if (!primaryButtonEnabled) {
      toasts.error(t('nav.create_button.fields_required'))
      return
    }

    const onProjectSaveClick = (val: boolean) => {
      if (!!val) {
        onPrimaryClick && onPrimaryClick();
        modalToggle.hide();
        return;
      }

      modalToggle.hide();
    } 

    modalToggle.show('project-publish', {
      onClick: onProjectSaveClick
    })
  }

  const isMainBookPreview = useMemo(() => (mainBookId && isBookChapterPreview), [isBookChapterPreview, mainBookId ])

  const shouldVisibleTeamPreview = useMemo(
    () => isTeamEdit && !!previewButtonVisible,
    [isTeamEdit, previewButtonVisible]
  );

  const mobileIconState = useMemo(
    () => mobileEditorOpen ? IconStates.button : IconStates.close, [mobileEditorOpen, closeIconVisible])

  const isAgeytomesh = AppTester.isAgeytomesh();
  const isHseAnimation = AppTester.isHseAnimation();
  const isGeo = AppTester.isGeograffee();
  const isHSEDesign = AppTester.isHSEDesign();
  const isDeziiign = AppTester.isDeziiign();
  const isOnlines = AppTester.isOnlines();
  const isSchool = AppTester.isSchool();
  const isSuperPuper = AppTester.isSuperPuper();
  const isDvaDesign = AppTester.isDvaDesign();
  const isGalllleryArt = AppTester.isGalllleryArt();
  const isDamuseum = AppTester.isDaMuseum();
  const isStartHSE = AppTester.isStartHSE();
  const isContinuumSite = AppTester.isContinuumSite();
  const isKiiidsArt = AppTester.isKiiidsArt()
  const is743 = useBreakpoint(743)

  const isDafes = AppTester.isGeoDafes();
  const isBooks = !!useRouteMatch([
    LinkTo.hseBooks,
    "/hsebooks",
  ]);
  const isDesignBooks = AppTester.isBooksMain();
  const isGalllleryBooks = AppTester.isBooksGallllery();
  const isHseColors = AppTester.isHseColors();
  const isGameDeziiign = AppTester.isGameDeziiign();

  const isVisualResearch = !!useRouteMatch("/visualResearch");

  const isTagsModalActive =
    useSelector(modalControllerSelector).name === "tags";
  const isReportModalActive =
    useSelector(modalControllerSelector).name === "report";
  const isCompetitionSendProjectActive =
    useSelector(modalControllerSelector).name === "send-project";
  const isNotSavedDataModal =
    useSelector(modalControllerSelector).name === "not-saved-data";
  const isCompetitionLongreadSendProjectActive = useSelector(modalControllerSelector).name === "send-project-longread"

  const menuVisible = useMemo(
    () => (isOpen && !isNotSavedDataModal) 
  , [isOpen, isNotSavedDataModal])

  const isGeoTagModalActive = useSelector(GeoTagModalSelector)?.modalIsOpen;
  const setTheme = isSuperPuper || isCGRave || isContinuumSite || isAdcrDafesNet
    ? ApplicationTheme.black
    : isDafes
    ? ApplicationTheme.white
    : isGeo
    ? ApplicationTheme.grey
    : isGameDeziiign
    ? ApplicationTheme.additionalGreyTheme
    : isGalllleryBooks
    ? ApplicationTheme.additionalWhite_1
    : ApplicationTheme.white;

  const isDeziiignOrGeo = isDeziiign || isGeo;

  const profile = useProfile();
  const isCompetitions = location.pathname.startsWith(LinkTo.awards);
  const isModer = useMemo(
    () => profile && bProfile.isModer(profile),
    [profile]
  );
  const canViewSuperGames = useMemo(
      () => (profile && profile.rolesList && Array.isArray(profile.rolesList) && (new ProfileRole(HsePolicies.can_view_games)).containsIn(profile.rolesList)
    ), [profile]);
  const isCreateLocationPage = !!useRouteMatch(LinkTo.createLocation);
  
  const isTeamAdmin = useRouteMatch<{ id: string }>('/teamAdmin');
  const isTeacher = bProfile.isEmployee(profile);
  const isEdit = useRouteMatch<{ id: string }>("/edit/:id");
  const isTeam = !!useRouteMatch("/teams/:id");
  const isHseMain = useMemo(() => (AppTester.isContext('hsedesign')), [])
  const isDaMuseum = AppTester.isDaMuseum();
  const isProHse = AppTester.isProHSE();
  const isPro = AppTester.isProDeziiign()
  const isCreativeHSE = AppTester.isCreativeHSE();
  const isLMSHSECreative = AppTester.isLMSHSECreative();
  
  const context = getContextFromAppName(ApplicationShared.application);

  const { 
      channels, 
      loading
  } = useChannelsContext();

  const shouldVisibleFeedButton = useGetFeedInfo();

  const shouldVisibleChannelButton = useMemo(() => {
    if (loading || !profile || channels?.length === 0) return false
    return channels?.some((channel) => {
      return hasPersonalChannel(channel, profile) || hasDefaultChannel(channel,profile)
    })
  } , [channels, profile, loading])

  const isJuniorModer = useMemo(
    () => profile && profile?.rolesList?.includes("juniormoder"),
    [profile]
  );

  const { name: modalName }: ModalControllerSlice = useSelector(
    modalControllerSelector
  );

  const { teamName } = useParams<{teamName: string}>();
  const team = useExternalOrganization(teamName);

  const isTeamOwner = useMemo(
    () => {
      const tTeam = team as Team;

      if (!profile || !team) return undefined;

      return tTeam?.ownersIDs?.includes(profile?.accountId)
    } 
  , [team, profile])
  // @ts-ignore
  const isLMS = AppTester.isLMSHSE() || team?.moderationType == ModerationType.LMS;
  const isShouldVisibleLMSButton = useMemo(() => Boolean(!isTeamAdmin && (!isLMS || (team && (isTeamOwner || isModer || isTeacher)))), [isTeamAdmin, isLMS, team, isTeamOwner, isModer, isTeacher]);

  const isMobileSelectTags = useMemo(
    () =>
      modalName === "tags" &&
      (isEdit ||
        isBookEdit ||
        isCreateLocationPage ||
        isTeamEdit ||
        isBooksEdit ||
        isCompetitionEdit) &&
      isMobile,
    [
      isEdit,
      isBookEdit,
      isBooksEdit,
      isCompetitionEdit,
      isTeamEdit,
      isCreateLocationPage,
      modalName,
      isMobile,
    ]
  );
  const shouldDisplayCreateButton = useMemo(
      () => {

        if (isProjectEdit || isBookEdit || isTeamEdit || isProfileEdit || isCompetitionEdit || (isMobileSelectTags && isCreateLocationPage) || isOpen) return false;

        //@ts-ignore
        return isHSEDesign? isProHse || isDaMuseum || isHseMain || (isCompetitions && !isStartHSE) || isCreativeHSE || (!!team && !!team?.isCanCreateProject) :
        
        (((isTeam && (isModer || isTeamOwner)) || !isLMS) && !isTeamAdmin && !isLMSHSECreative &&
        ![
          "places",
          "ageytomesh",
          "education",
          'dafes',
          "dvadesign",
          "superpuper",
          "galllleryart",
        ].includes(context) &&
        !(isSuperPuper && !(isModer || isJuniorModer)))
    }
    , [isProjectEdit, isBookEdit, isTeamEdit, isProfileEdit, isCompetitionEdit, isMobileSelectTags, isCreateLocationPage, isOpen, isKiiidsArt, is743, isHSEDesign, isProHse, isDaMuseum, isHseMain, isCompetitions, isStartHSE, isCreativeHSE, team, isTeam, isModer, isTeamOwner, isLMS, isTeamAdmin, isLMSHSECreative, context, isSuperPuper, isJuniorModer]);

  const shouldDisplayContextOnNavbar = useMemo(
    () => isHSEDesign && !isProfilePage,
    [isHSEDesign, isProfilePage]
  );

  const shouldVisibleSaveBtn = useMemo(
    () => (((isProjectEdit || isBookEdit || isTeamEdit || isCompetitionEdit) && isTablet && !is744 && primaryButtonVisible) || (isProfileEdit && !is744)) && !isCompetitionLongreadSendProjectActive,
    [
      isProjectEdit, 
      isBookEdit, 
      isTeamEdit, 
      isTablet, 
      isProfileEdit, 
      is744, 
      isCompetitionLongreadSendProjectActive, 
      primaryButtonVisible, 
      isCompetitionEdit
    ]
  );
  const shouldVisibleCourseList = useMemo(
    () => isMobile && isLMS && !isTagsModalActive,
    [isMobile, isLMS, isTagsModalActive]
  );

  const PhoneButton = useMemo(() => (isHseColors && !isOpen && (
    <FlexBox offsetRight={isMobile ? 16 : 0}>
        <RectangularButtonFilled smallPadding onClick={() => navigator.clipboard.writeText('79999999999').then(() => toasts.info(t && t('phone_copied')))}>
          <PhoneText style={{color: Colors.geoWhite100}}>
            +7 999 999 99-99
          </PhoneText>
        </RectangularButtonFilled>
    </FlexBox>
  )) , [isHseColors, isMobile, toasts, t, isOpen])
  //@ts-ignore
  const isModulesLMSHSE = team?.moderationType == ModerationType.LMS || location.pathname?.includes('courses')

  const createButtonTitle = useMemo(
    () =>
        isModulesLMSHSE
        ? t("nav.create_button.create_modul") :isCompetitions
        ? t("nav.create_button.create_competition")
        : isKiiidsArt ? t('nav.create_button.add_work_kiiids') : isBooks || isDesignBooks || isGalllleryBooks
        ? t("nav.create_button.create_book") : isBrnd 
        ? t("nav.create_button.add_work"): isProDeziiign || isProHSE || isSpacePro
        ? t("nav.create_button.create_presentation")
        : t("nav.create_button.create_project"),
    [isModulesLMSHSE, t, isCompetitions, isKiiidsArt, isBooks, isDesignBooks, isGalllleryBooks, isBrnd, isProDeziiign, isProHSE]
  );

  // очередной костыль, я не понимаю почему у меня выдает ошибки при каждом изменний условий
  const isNeedTeamButtons = useMemo(
    () => isTeamEdit && !isCompetitionLongreadSendProjectActive && (secondaryButtonVisible || primaryButtonVisible)
  , [isCompetitionLongreadSendProjectActive, isTeamEdit, primaryButtonVisible])

const cardUrl = Endpoints.cardsMnePw;


const createKidsCard = useCallback(async () => {
    if (!profile) {
      return
    }
    const catalogs = await API.request()
                          .endpoint(cardUrl)
                          .url('api/Collection/GetCatalogs')
                          .get()
                          .addQuery('service', 'kids')
                          .addQuery('userId', profile?.accountId)
                          .addQuery('isUserCatalog', 'true')
                          .send()
                          .then((r: any) => r.json())
    
    const collectionId = catalogs?.[0]?.cardCollectionId


    const cardData : any = {
      "museumId": collectionId || null,
      "countryId": null,
      "artistId": profile?.accountId,
      "name": null,
      "images": null,
      "dateString": null,
      "isSelfPortrait": false,
      "isFragment": false,
      "isGameArt": false,
      "isLongreadGenerator": false,
      "isLongreadGeneratorTitle": false,
      "cardPersons": null,
      "creationCountry": null,
      "styleTime": null,
      "realMuseum": null,
      "styleLocation": null,
      "style": null,
      "objects": null,
      "userCollectionId": null,
      "mythologicalStories": null,
      "stories": null,
      "tagIds": null,
      "statusCard": 0,
      "mediaLink": "",
      "typeCard": "t_kids"
  }

    const createdCard: any = await API.Json(CardAPI.AddCard(cardData))
                              
    if (createdCard) window.open(`${process.env.REACT_APP_URL_KIIIDS_ART}/card/${createdCard}`, '_self')
  }, [cardUrl, profile])


  const isShadowModal = useMemo(
    () => SHARED_MODALS[modal?.name]?.shadowClosableBackground,
    [modal?.name]
  );
  const isActiveModal = useMemo(
    () => Boolean(modalName) && !isShadowModal,
    [modalName, isShadowModal]
  );
  const isMobileEditorOpen = useMemo(
    () => (mobileEditorOpen && isMobile && !!toggleMobileEditor) || false,
    [mobileEditorOpen, isMobile, toggleMobileEditor]
  );

  const teamsList = useMemo(() => {
    let res = [];
    for (let key in ORGANIZATION_LIST) {
      //@ts-ignore
      if (!["ageytomesh", "books"].includes(key) &&!ORGANIZATION_LIST[key].disabled
      ) {
        res.push({
          //@ts-ignore
          title: ORGANIZATION_LIST[key]?.[language === "ru" ? "titleRu" : "title"],
          name: key,
          value: `/teams/${key}`,
          ctx: "",
          active: location.pathname?.includes(key),
          external: false,
          isTeam: true,
        });
      }
    }
    return res;
  }, [location, language]);

  const urlsList = useMemo(
    () => [
      {
        title: t("nav.laboratory").toLowerCase(),
        name: "laboratory",
        value: "/teams/hselab",
        ctx: "",
        active:
          location.pathname.includes("/hselab") &&
          !location.search.includes("design"),
        external: false,
        isTeam: true,
      },
      ...teamsList,
    ],
    [location, teamsList, t]
  );


  const { onSave: onModalTagsSave, selectedTags } = useSelector(TagsSelector);

  const handleToggleMobileMenu = useCallback(
    (val: boolean) => {
      dispatch(MobileMenuStateAction.toggle(val));
      dispatch(setIsOpen(val));
    },
    [dispatch]
  );

  
  const handleModalTagSave = useCallback(() => {
    if (onModalTagsSave) onModalTagsSave(selectedTags);
    dispatch(setIsOpen(false));
    hideModal();
  } , [onModalTagsSave, hideModal, selectedTags, dispatch])

  const saveTagsMobileButtonVisible = useMemo(() => {
    if (is568bp && isGeo) return false;
    return isMobileSelectTags && !(isProHse || isPro) && is744
  } , [is568bp, isGeo, isMobileSelectTags, isProHse, isPro, is744])

  const onOnlinesLangSwitch = useCallback(
    (lang: string) => {
      // @ts-ignore
      SaveUserLang(lang);
      dispatch(setAppLang(lang));
      setQueryParams({ lang });
      i18n.changeLanguage(lang, () => window.location.reload());
    },
    [setQueryParams, dispatch, i18n]
  );

  const handleLangChange = () => {
    onLangSwitch?.();
    //todo indicate somehow that language is changed
  };

  const handleLogoClick = () => {
    if (isOnlines) {
      history.push("/");
    }
    //@ts-ignore
    isIllustration && !isTagsModalActive
      ? (window.location.href = process.env.REACT_APP_URL_HSEDESIGN_RU || "")
      : history.push(LinkTo.explore);
    //todo move everything to shared modals
    setVisibleModalMenuCategoriesMobile(false);
    handleToggleMobileMenu(false);
    hideModal();
    toggleMobileEditor && toggleMobileEditor(false);
  };

  const locationDep = location.pathname;

  useEffect(
    () => () => {
      setVisibleModalMenuCategoriesMobile(false);
      handleToggleMobileMenu(false);
      if(modal.name !== "paymentManager"){
        hideModal();
      }
    },
    [handleToggleMobileMenu, hideModal, locationDep]
  );

  useEffect(() => {
    setUserParam();
  }, [location, setUserParam]);

  useEffect(() => {
    if (isOnlines) {
      i18n.changeLanguage(lang);
    }
  }, [isOnlines, i18n, lang]);

  const theming = useMemo(
    () => ({
      zIndex: 99999,
      backgroundColor: !isGeo && !isGameDeziiign && !isCGRave
        ? theme.navigationBar.backgroundColor
        : theme.app.backgroundColor,
      borderBottomColor: theme.navigationBar.borderBottomColor,
      backgroundScrolling: theme.navigationBar.backgroundScrollingColor,
      boxShadow: theme.navigationBar.boxShadow,
      mobile: true,
    }),
    [
      isGeo,
      theme.app.backgroundColor,
      theme.navigationBar.backgroundColor,
      theme.navigationBar.backgroundScrollingColor,
      theme.navigationBar.borderBottomColor,
      theme.navigationBar.boxShadow,
    ]
  );

  const shouldDisplaySearchBar = useMemo(
    () =>
      !isMobile &&
      !isProjectEdit &&
      !isCompetitionEdit &&
      !isBookEdit &&
        (getShouldDisplaySearch()),
    [
      isMobile,
      isOnlines,
      isSchool,
      isProjectEdit,
      isCompetitionEdit,
      isBookEdit,
      isAgeytomesh,
      isHseAnimation,
      isDvaDesign,
      isGalllleryArt
    ]
  );

  const shouldDisplayLangSwitcher = useMemo(() => {
    if (isGreenAward || isLPU) {
      return null;
    }
    if (isLMS && isProjectEdit) {
      return null;
    }

    if ((isProjectEdit || isBookEdit) && !is744 && !(
      !isGreenAward && 
      !isBrnd && 
      !isSuperPuper && 
      !isLPU && 
      (isOpen || isTagsModalActive || isActiveModal) 
      && !isOnlines && 
      !isMobileSelectTags
    )) {
      return true;
    }

    if ((!isSuperPuper && !isLPU && (isOpen ||
      isTagsModalActive ||
      isActiveModal) &&
      !isGreenAward &&
      !isOnlines &&
      !isMobileSelectTags )) {
      return true;
    }

    return true;
  } , [
    isProjectEdit,
    isBookEdit,
    is744,
    isBrnd,
    isLPU,
    isOpen,
    isOnlines,
    isMobileSelectTags,
    isActiveModal,
    isTagsModalActive,
    isReportModalActive,
    isCompetitionEdit,
    isSchool,
    isGreenAward,
    isLMS,
    isSuperPuper,
    isMobile
  ])

  const onCreateClick = useCallback(() => {
   
    if (token) {
      if (isKiiidsArt) {
        createKidsCard()
        return
      }
      if (isCompetitions) {
        history.push(CreateLinkTo.competitionCreate());
      } else if (isBooks || isDesignBooks || isGalllleryBooks /*|| isVisualResearch*/) {
        history.push(CreateLinkTo.bookCreate());
      } else {
        history.push(CreateLinkTo.projectCreate());
      }
    } else {
      emit("login");
    }
  }, [token, isKiiidsArt, isCompetitions, isBooks, isDesignBooks, isGalllleryBooks, createKidsCard, history, emit]);

  const onPreviewExit = useCallback(() => {
    if (token && id) {
        isMainBookPreview 
        ? history.push(CreateLinkTo.bookEdit(mainBookId)) 
        : isBookChapterPreview
        ? history.push(CreateLinkTo.bookEdit(id))
        : isBooks
        ? history.push(CreateLinkTo.bookEdit(id))
        : isTeamPreview
        ? history.push(CreateLinkTo.teamEdit(id))
        : isTeamLgPreview
        ? history.push(CreateLinkTo.teamEdit(id) + "?tab=lg")
        : history.push(CreateLinkTo.projectEdit(id));
    }
  }, [
    token,
    id,
    isBookChapterPreview,
    isMainBookPreview,
    mainBookId,
    history,
    isBooks,
    isTeamPreview,
    isTeamLgPreview,
  ]);
  
  return (
    <ThemeProvider theme={setTheme}>
      <NavBarWrapper isKiiidsArt={isKiiidsArt}>
      <NavBar
        theming={theming}
        logo={mainLogo}
        onLogoClick={handleLogoClick}
        context={
          shouldDisplayContextOnNavbar ? t(`context_names.${contextName}`) : ""
        }
        sections={[
          [
            ...(!isOpen &&
            !isTagsModalActive &&
            !isCompetitionLongreadSendProjectActive &&
            !isMobileEditorOpen &&
            !isProjectOnlyEdit &&
            !isProjectPreview
              ? [
                  <AbsoluteWrapper centered={false} isTeamEdit>
                    {(isProjectEdit ||
                      isCompetitionEdit ||
                      isBookEdit ||
                      shouldVisibleTeamPreview) &&
                      !!onPreviewClick && (
                        <div id="preview-button" onClick={onPreviewClick}>
                          <PreviewIconOpen />
                        </div>
                      )}
                    {isPreview && !!onPreviewExit && (
                      <div id="preview-button" onClick={onPreviewExit}>
                        <IconWrapper>
                          <PreviewIconClosed />
                        </IconWrapper>
                      </div>
                    )}
                  </AbsoluteWrapper>,
                ]
              : []),
          ],
          [
            ...(isOnlines
              ? [
                  <>
                    {!isOpen && (
                      <NeutralLink to="/open-day">
                        <OpenDayButton>
                          {t("onlinesNav.btns.open_day")}
                        </OpenDayButton>
                      </NeutralLink>
                    )}
                    {(isOpen || isTagsModalActive) && isOnlines && (
                      <BLanguageSelectionComponentOnlines
                        onLangSelect={onOnlinesLangSwitch}
                        key="lang"
                      />
                    )}
                    {!isOpen && (
                      <ApplyBtn
                        lang={i18n.language}
                        href={ANCHOR_ONLINES_LINK + onlinesUserParam}
                        size={"small"}
                      >
                        {t("onlinesNav.btns.apply")}
                      </ApplyBtn>
                    )}
                  </>,
                ]
              : [
                  <RightSection>
                    {!is744 && !isOpen &&
                        !isTagsModalActive &&
                        !isMobileEditorOpen &&
                        (isProjectOnlyEdit || isProjectPreview) && (
                            <AbsoluteWrapper offsetRight={16} centered={false} isTeamEdit>
                              <MobileSaveBlock
                                  onClick={onMobileProjectSaveClick}
                                  visible={is744}/>
                              {(isProjectEdit ||
                                      isBookEdit ||
                                      isCompetitionEdit ||
                                      shouldVisibleTeamPreview) &&
                                  !!onPreviewClick && (
                                      <div id="preview-button" onClick={onPreviewClick}>
                                        <PreviewIconOpen />
                                      </div>
                                  )}
                              {isPreview && !!onPreviewExit && (
                                  <div id="preview-button" onClick={onPreviewExit}>
                                    <IconWrapper>
                                      <PreviewIconClosed />
                                    </IconWrapper>
                                  </div>
                              )}
                            </AbsoluteWrapper>
                        )}
                    {shouldDisplaySearchBar && !isOpen && (
                      <MainSearchButton />
                    )}
                    {!isPreview &&
                      !isProjectEdit &&
                      !isBookEdit &&
                      !isCompetitionEdit &&
                      !isTeamEdit &&
                      !isActiveModal &&
                      !isOpen && (
                        <>
                          {!isDvaDesign && !isAgeytomesh && (
                            <>
                              <NotificationsController/>
                              {shouldVisibleChannelButton && <ChannelButton />}
                              {shouldVisibleFeedButton && <FeedButton />}
                            </>
                          )}
                          <TeamInfo />
                        </>
                      )}
                    {(isModer || canViewSuperGames) && isMedia && !isLectureMediiia &&  <GameButton />}
                    {shouldDisplayLangSwitcher && (
                        <LangSwitcherWrapper
                          isOpen={isOpen} 
                          isKiiidsArt={isKiiidsArt}
                          offsetRight={isSuperPuper ? 6 : 16}
                          offsetLeft={16}
                        >
                          <BLangSwitcher
                            currentLanguage={i18n.language}
                            onLangSelect={handleLangChange}
                            key="lang"
                            mobile
                            activeBg={isKiiidsArt ? '#94209E' : ''}
                            itemStyle={isKiiidsArt ? 'border-radius: 8px;' : ''}
                          />
                        </LangSwitcherWrapper>
                      )}
                    {PhoneButton}
                    {                   
                      isCompetitions 
                        ? 
                          isSchool
                        : 
                          (isSchool &&
                          !isShouldVisibleLMSButton)?
                          <></> :
                          shouldDisplayCreateButton && !isGreenAward && !is430bp && !modalName ?
                          (
                            <DropdownWrapper key="mobile-create-dropdown">
                            {isDropdownEnabled ? (
                              <ProjectEditPageGridInput isColumns>
                                <CustomDropdown
                                lang={i18n.language}
                                value={navProTypeValue}
                                onChange={onDropdownChange}
                                onMenuOpen={() => {
                                  dispatch(NavbarSearchActions.setNavbarSearchToggle({ data: false }));
                                  document.body.click();
                                }}
                                options={proTypeOptions}
                                placeholder={createButtonTitle ?? "Выбрать тип"}
                                
                              />
                              </ProjectEditPageGridInput>
                              
                            ) : (
                              <CreateButton style={isGreenAward ? { marginLeft: '10px' } : {}} onClick={onCreateClick} isKiiids={isKiiidsArt} isMedia={isMedia}>
                                {createButtonTitle}
                              </CreateButton>
                            )}
                          </DropdownWrapper>
                      ): <></>
                    }
                    {false &&
                      isProfileEdit &&
                      !!onPrimaryClick &&
                      !!onSecondaryClick &&
                      !isOpen && (
                        <FlexBox>
                          <RectangularButtonFilled
                            style={{
                              minWidth: "77px",
                              maxWidth: "77px",
                              marginRight: "10px",
                            }}
                            onClick={onPrimaryClick}
                          >
                            {primaryButtonText}
                          </RectangularButtonFilled>
                          <RectangularButtonHollow
                            style={{ minWidth: "77px", maxWidth: "77px" }}
                            onClick={onSecondaryClick}
                          >
                            {secondaryButtonText}
                          </RectangularButtonHollow>
                        </FlexBox>
                      )}
                    {shouldVisibleCourseList && <CourseInfoListController />}
                    {is744 && !isOpen &&
                      !isTagsModalActive &&
                      !isMobileEditorOpen &&
                      (isProjectOnlyEdit || isProjectPreview) && (
                        <AbsoluteWrapper offsetRight={16} centered={false} isTeamEdit>
                          {!(isLMS && isProjectEdit) && (
                            <MobileSaveBlock
                              onClick={onMobileProjectSaveClick}
                              visible={is744}/>
                          )}
                          {(isProjectEdit ||
                            isBookEdit ||
                            isCompetitionEdit ||
                            shouldVisibleTeamPreview) &&
                            !!onPreviewClick && (
                              <div id="preview-button" onClick={onPreviewClick}>
                                <PreviewIconOpen />
                              </div>
                            )}
                          {isPreview && !!onPreviewExit && (
                            <div id="preview-button" onClick={onPreviewExit}>
                              <IconWrapper>
                                <PreviewIconClosed />
                              </IconWrapper>
                            </div>
                          )}
                        </AbsoluteWrapper>
                      )}
                    {is744 &&
                      (!!onSecondaryClick || isPreview) &&
                      !isProfileEdit &&
                      !isTeamEdit &&
                      !isOpen &&
                      !isMobileSelectTags &&
                      (isProjectOnlyEdit || isProjectPreview || isBookEdit || isBookChapterPreview || isBooksGallllery) && (
                        <AgreeButtonWrapper
                          disabled={!canSaveLgText}
                          isPreview={!!isPreview}
                          onClick={
                              isPreview
                              ? () => history.push(CreateLinkTo.explore())
                              : onSecondaryClick
                          }
                          {...theme.navigationBar.login}
                        >
                          <AgreeOrClose type={mobileIconState} enabled={true} />
                        </AgreeButtonWrapper>
                      )}
                    {is568bp &&
                      (!!onSecondaryClick || isPreview) &&
                      !isProfileEdit &&
                      !isTeamEdit &&
                      !isBookEdit &&
                      !isBookChapterPreview &&
                      !isOpen &&
                      !isMobileSelectTags &&
                      !isProjectOnlyEdit &&
                      !isProjectPreview && (
                        <ProjectSaveButton
                          disabled={!canSaveInDrafts || !previewButtonEnabled}
                          fixedSize
                          style={{ marginRight: "11px" }}
                          onClick={
                            isPreview
                              ? () => history.push(CreateLinkTo.explore())
                              : onSecondaryClick
                          }
                          {...theme.navigationBar.login}
                        >
                          {t("project_edit.save")}
                        </ProjectSaveButton>
                      )}
                    {shouldVisibleSaveBtn &&
                      !isMobileSelectTags &&
                      !isOpen && (
                        <ProjectSaveButton
                          disabled={!primaryButtonEnabled}
                          onClick={onPrimaryClick}
                        >
                          {isTeamEdit
                            ? primaryButtonText
                            : t("project_edit.save")}
                        </ProjectSaveButton>
                      )}

                    {/*КНОПКИ ДЛЯ РЕДАКТИРОВАНИЯ  ОРГАНИЗАЦИЙ В МОДЕРКЕ*/}
                    {isNeedTeamButtons &&
                      is568bp &&
                        !isMobileSelectTags &&
                      !isOpen && (
                        <ExitButton isTeamEdit onClick={onSecondaryClick}>
                          {secondaryButtonText}
                        </ExitButton>
                    )}
                    {isNeedTeamButtons &&
                      is568bp &&
                      !isMobileSelectTags &&
                      !isOpen && (
                        <ProjectSaveButton
                          style={{ marginLeft: 8 }}
                          fixedSize
                          disabled={!primaryButtonEnabled}
                          onClick={onPrimaryClick}
                        >
                          {primaryButtonText}
                        </ProjectSaveButton>
                      )}

                    {saveTagsMobileButtonVisible && (
                      <SaveButton
                        onClick={handleModalTagSave}
                      >
                        {t("project_edit.save")}
                      </SaveButton>
                    )}
                    {!isCompetitionLongreadSendProjectActive && !is744 &&
                      (isProjectEdit || isBookEdit || isTeamEdit || isCompetitionEdit || (isProfileEdit && !is744)) &&
                      !isMobileSelectTags &&
                      !isPreview &&
                      !isMobileEditorOpen &&
                      !isGeoTagModalActive &&
                      !isOpen &&
                      secondaryButtonVisible && (
                        <ExitButton
                          style={{ ...(isProfileEdit && {marginRight: 16} )}}
                          fixedSize
                          onClick={() =>
                            (isBookEdit || isTeamEdit || isBooksEdit || isProfileEdit || isProjectEdit || isCompetitionEdit) &&
                            onSecondaryClick
                              ? onSecondaryClick()
                              : history.push(CreateLinkTo.explore())
                          }
                        >
                          {isTeamEdit
                            ? secondaryButtonText
                            : t("nav.exit_other") ?? "Exit"}
                        </ExitButton>
                      )}
                    
                    {!isProjectEdit &&
                      !isTeamEdit &&
                      !isBookEdit &&
                      !isCompetitionEdit &&
                      !isPreview &&
                      !isOpen &&
                      !isTagsModalActive &&
                      !isActiveModal && <WidgetLogin />}
                    {!isSuperPuper && !isLPU && (isOpen ||
                      isTagsModalActive ||
                      isActiveModal) &&
                      !isGreenAward &&
                      !isOnlines &&
                      !isMobileSelectTags && (
                        <>
                        <WidgetLogin /> 
                        </>
                      )}
                  </RightSection>,
                ]),
          ],
        ]}
      />

      <ModalMenuContextMobileNew
        hseUrls={urlsList}
        visible={menuVisible}
        closeMenu={closePopup}
      />

      <MobileBottomBar
        primaryButtonData={{
          onClick: onPrimaryClick,
          enabled: primaryButtonEnabled,
          text: primaryButtonText,
        }}
        onSave={handleModalTagSave}
        isMobileEditorOpen={isMobileEditorOpen}
      />
      </NavBarWrapper>
    </ThemeProvider>
  );
};

export default DeziignNavBarMobile;
import {
  FC,
  useMemo,
  useCallback,
  useState,
  useEffect,
  ReactElement,
} from "react";
import {useHistory, useLocation, useParams, useRouteMatch} from "react-router-dom";
import styled, { useTheme, ThemeProvider, css } from "styled-components";
import { useTranslation } from "react-i18next";
import {
  LayoutConst,
  modalControllerActions,
  modalControllerSelector,
  ModalControllerSlice,
  SHARED_MODALS,
  useModal,
} from "core";
import {
  AppTester,
  getContextFromAppName,
} from "supporting";
import { ApplicationShared } from "core";
import { ApplicationTheme } from "shared/themes";
import { useAuth } from "core/hooks/auth/useAuth";
import { NavBar } from "shared/components/__FOX__/NAV/src";
import { CreateLinkTo, LinkTo } from "shared/constants/linkTo";
import WidgetLogin from "./WidgetLogin";
import MobileBottomBar from "./MobileBottomBar";
import { useSelector, useDispatch } from "react-redux";
import {
  RectangularButtonFilled,
  RectangularButtonHollow,
} from "../components/buttons";
import {
  FlexBox,
  FInter,
  useIsMobile,
  useBreakpoint,
  BLangSwitcher,
  NavbarButtonFilled,
  Colors,
  useToasts} from "@brg/ui";
import { AbsoluteWrapper } from "../components/navbar-elements/navbar-create";
import PreviewIconOpen from "../assets/32/PreviewIconOpen";
import PreviewIconClosed from "../assets/32/PreviewIconClosed";
import { ModalMenuContextMobileNew } from "./ModalMenuContextMobileNew";
import { NeutralLink } from "shared/components/link/styles";
import {
  ANCHOR_ONLINES_LINK,
  ApplyBtn,
} from "shared/components/Footer/OnlinesFooter";
import { BLanguageSelectionComponentOnlines } from "core/components/BLanguageSelectionComponentOnlines";
import { SaveUserLang } from "shared/components/__ADDONS__/__LANG__/Utils/GetUserLang";
import { setAppLang } from "shared/components/__ADDONS__/__LANG__/Slice";
import useQueryState from "shared/hooks/useQueryState";
import { OpenDayButton } from "./DeziiignNavbar";
import { useOnlinesParam } from "shared/hooks/OnlinesParamFilter";
import { useContextsTabs } from "shared/hooks/useContextsTabs";
import { MobileMenuStateAction } from "shared/reducers/mobileMenuOpen";
import { bProfile, ProfileRole, useProfile } from "@brg/auth";
import { TagsSelector } from "../reducers/Tags";
import { DropdownWrapper } from "./HSEDeziiignNavbar";
import { DropdownWithExternalsLinks } from "./components/contextTabsItems";
import { ORGANIZATION_LIST } from "shared/hooks/useGetCurrentTeam";
import { GeoTagModalSelector } from "shared/reducers/geoTagsModal";
import NotificationsController from "../components/NotificationsController/NotificationsController";
import { MainSearchButton } from "shared/components/MainSearchController/MainSearchButton";
import TeamInfo, { PhoneText } from "../components/TeamInfo/TeamInfo";
import { CourseInfoListController } from "shared/components/CourseInfoListController/CourseInfoListController";
import useExternalOrganization from "../pages/exploreHseContextsNew/useExternalOrganization";
import {ModerationType} from "../pages/teams/const/ModerationTypes";
import { AgreeOrClose, IconStates } from "./components/AgreeOrClose";
import { MobileSaveBlock } from "./components/MobileSaveBlock";
import FeedButton from "../components/NotificationsController/FeedButton";
import { setIsOpen } from "shared/reducers/OpenModal";
import { useGetLogo } from "shared/components/navigationSystem/useGetLogo";
import {getShouldDisplaySearch} from "../helpers/getShouldDisplaySearch";
import { API, CardAPI, Endpoints, Team } from "@brg/api";
import { Input } from "@brg/input";
import { ProjectEditPageGridInput } from "_deziiign/books/pages/BookEdit/styles";
import ChannelButton from "shared/components/NotificationsController/ChannelButton";
import { NavbarSearchActions } from "shared/reducers/NavbarSearch";
import GameButton from "shared/components/NotificationsController/GameButton";
import { useChannelsContext } from "shared/contexts/ChannelsContext";
import { hasDefaultChannel, hasPersonalChannel } from "shared/helpers/teamsStatus";
import { useGetFeedInfo } from "shared/hooks/api/useGetFeedInfo";
import { HsePolicies } from "shared/constants/HsePolicies";

export const DropdowCreateProjectnWrapper = styled(FlexBox)`
  white-space: nowrap;
`;

const CustomDropdown = styled(Input.Dropdown)`
  .brg-input__control {
    height: 20px !important;
    width: ${p => p.lang === 'en' ? '219px' : '250px'} !important;
    color: #FEFEFE !important;
    background-color: #151514 !important;
    border: 1px solid #444 !important;
    box-shadow: none !important;
    padding-left: 8px;
    cursor: pointer;
  }
    
  .brg-input__value-container{
    height: 100% !important;
    margin-top: -3px;
  }

  .brg-input__control:hover svg {
    fill:  #FEFEFE !important;
    color: #FEFEFE !important;
  }

  .brg-input__placeholder{
    color: #FEFEFE !important;
    font-weight: 600;
    white-space: nowrap;
  },

  .brg-input__placeholder:hover{
    color: #FEFEFE !important;
  }
  .brg-input__control:hover .brg-input__placeholder {
    color: #FEFEFE !important;
  }

 .brg-input__menu {
    width: 250px;
    border-radius: 3px;
    margin-top: 8px;
  }

  .brg-input__menu-list {
    padding: 0;
  }

  .brg-input__option {
    color: #ddd !important;
    padding: 8px 12px;
  }

  .brg-input__indicator {
    width: auto;
    height: 34px;
  }

  .brg-input__dropdown-indicator svg path{
    fill: #fefefe !important;
  }

.brg-input__dropdown-indicator{
    opacity: 1;
    margin-right: 14px;
    padding: 8px 8px 8px 10px;
  }

  .brg-input__control:hover svg { fill: #FEFEFE !important; }

  @media (max-width: ${LayoutConst.screen.l}px) {
    .brg-input__control {
      margin: 0 17px;
    }
      
    .brg-input__menu{
      margin-left: 17px;
    }
  }
`;

export const Burger = styled(FlexBox)`
  height: 40px;
  align-items: center;
  opacity: 1;
  transition: all 0.2s;

  &:hover {
    opacity: 1;
  }
  ${FlexBox} {
    @media (max-width: 568px) {
      margin-right: 6px; /* важно, изменения для всего сайта */
    }
  }
`;

export const NavbarOuter = styled(FlexBox)<{
  shifted?: boolean;
  isAgeytomesh?: boolean;
  logoLength?: number;
}>`
  max-width: 300px;
  position: relative;
  left: ${(p) => (p?.shifted ? `-${p?.logoLength}px` : 0)};
  transition: all 500ms;
`;

export const LogoName = styled(FlexBox)<{ isGeo?: boolean; isDafes?: boolean }>`
  font-family: Inter, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: ${({ isDafes }) => isDafes ? '17px' : '24px'};
  line-height: ${({ isDafes }) => isDafes ? '22px' : '40px'};
  color: ${(p) =>
    p?.isDafes ? "#151514" : p.theme.navigationBar.logoName};
  position: relative;
  top: -1px;

  ${(p) =>
    p?.isGeo
      ? css`
          font-size: 17px;
          line-height: 22px;
          top: 1px;
        `
      : null};
`;

const RightSection = styled.div<{ isDafes?: boolean }>`
  display: flex;
  align-items: center;
`;

const CreateButton = styled.div<{ hide?: boolean, isMedia?: boolean, isKiiids?: boolean }>`
  display: ${({ hide }) => (hide ? "none" : "flex")};
  align-items: center;
  justify-content: center;
  padding: 4px 16px;
  background: ${({ theme, isKiiids }) => isKiiids? '#94209E' : theme.navigationBar.btns.create.bg};
  border-radius: ${({isMedia, isKiiids}) => isMedia || isKiiids ? '8px' : '3px'};
  font-family: Inter, sans-serif;
  font-style: normal;
  height: 36px;
  font-weight: 700;
  font-size: 15px;
  line-height: 20px;
  color: ${({ theme }) => theme.navigationBar.btns.create.color};
  margin-right: 16px;
  // min-width: 132px;
  min-width: auto;
  padding: 8px 24px;
  max-width: min-content;
  white-space: nowrap;

  @media (max-width: ${LayoutConst.screen.m_1024}px) {
    height: ${({isKiiids}) => isKiiids? 40 : 32}px;
  }

  // @media (max-width: ${LayoutConst.screen.sm}px) {
  //   height: 30px;
  //   margin-right: 6px;
  //   min-width: 84px;
  //   padding: 6px 15px;
  //   max-width: 84px;
  // }
`;

const ExitButton = styled(RectangularButtonHollow)<{ isTeamEdit?: boolean }>`
  margin-right: 14px;
  // width: 87px !important;
  // min-width: 87px !important;
  width: auto !important;
  min-width: auto !important;
  height: 36px !important;
  margin-left: 16px;
  margin-right: 0;
  font-weight: 600 !important;
  padding-left: 24px;
  padding-right: 24px;

  @media (max-width: ${LayoutConst.screen.sm}px) {
    height: ${({ isTeamEdit }) => (isTeamEdit ? "28px" : "26px")} !important;
    font-size: 13px;
    line-height: 16px;
    padding-left: 16px;
    padding-right: 16px;
  }

`;

const SaveButton = styled(NavbarButtonFilled)`
  width: auto;
  min-width: auto;
  max-width: none;
  line-height: 16px;
  height: 36px !important;
  padding: 4px 24px;
  min-height: 24px;
  margin-right: 6px;
  font-weight: 600 !important;
  letter-spacing: normal;
`;

const AgreeButtonWrapper = styled.button<{ disabled?: boolean, isPreview?: boolean }>`
    margin-bottom: 6px;
    cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
    pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
    user-select: ${({ disabled }) => (disabled ? "none" : "auto")};
    outline: none;
    border: none;
    background: none;
    padding: 0;
    ${({isPreview}) =>
      isPreview
        ? css`
            margin-right: 16px;
          `
        : null};

  svg {
    path {
      fill: ${Colors.galBlack47};
    }
  }

  &:hover {
    svg {
      path {
        fill: ${({ disabled }) =>
          disabled ? Colors.galBlack47 : Colors.galBlack100};
      }
    }
  }
  &:focus {
    outline: none;
  }
`;

const ProjectSaveButton = styled(NavbarButtonFilled)`
  // width: 132px;
  width: auto;
  min-width: auto;
  height: 36px !important;
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.02em;
  padding-left: 24px;
  padding-right: 24px;

  @media (max-width: 568px) {
    // width: 102px;
    // min-width: 102px;
    width: auto;
    min-width: auto;
    height: 28px !important;
    min-height: 28px;
    font-weight: 600;
    font-size: 13px;
    line-height: 16px;
    padding-left: 16px;
    padding-right: 16px;
  }

  &:disabled {
    background-color: ${({ theme }) =>
      theme.projectEdit?.btns?.navbar?.disabled?.bg} !important;
    color: ${({ theme }) =>
      theme.projectEdit?.btns?.navbar?.disabled?.color} !important;
  }
`;

const IconWrapper = styled(FlexBox)`
  & svg {
    stroke-width: 0.2px;
  }
`


const NavBarWrapper = styled.div<any>`
  ${p => p.isKiiidsArt && 
    css`
      div#navbar {
        margin: 0 40px;
        @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
          margin: 0 22px 0 32px;
        }
        @media (max-width: ${LayoutConst.screen.l}px), (max-width: ${LayoutConst.screen.sm}px) {
          margin: 0 16px;
        }
      }
    `
  }
`

const LangSwitcherWrapper = styled(FlexBox)<any>`
  div.langitem-active {
    ${p => p.isKiiidsArt && 'color: #FEFEFE;'}
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    margin: 0 8px 0 0;
  }

  @media (max-width: ${LayoutConst.screen.s-1}px) {
    margin: 0 8px 0 0;
  }
`

type PropsT = {
  onLangSwitch?: () => void;
  onPrimaryClick?: () => void;
  onSecondaryClick?: () => void;
  primaryButtonEnabled?: boolean;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  onPreviewClick?: () => void;
  dropdown?: ReactElement;
  currentTheme?: any;
  mobileEditorOpen?: boolean;
  canSaveInDrafts?: boolean;
  toggleMobileEditor?: (val: boolean) => void;
  previewButtonVisible?: boolean;
  previewButtonEnabled?: boolean;
  primaryButtonVisible?: boolean;
  secondaryButtonVisible?: boolean;
  closeIconVisible?: boolean;
  canSaveLgText?: boolean;
  proTypeOptions?: any;
  navProTypeValue?: any;
  onProTypeChange: (opt: { label: string; value: string } | null) => void;
};

const DeziignNavBarMobile: FC<PropsT> = ({
  onLangSwitch,
  onPrimaryClick,
  onSecondaryClick,
  primaryButtonEnabled,
  previewButtonEnabled,
  primaryButtonVisible = true,
  secondaryButtonVisible = true,
  primaryButtonText,
  secondaryButtonText,
  onPreviewClick,
  mobileEditorOpen,
  toggleMobileEditor,
  canSaveInDrafts,
  previewButtonVisible,
  closeIconVisible = false,
  canSaveLgText,
  proTypeOptions,
  onProTypeChange
}) => {
  const theme = useTheme();
  const history = useHistory();
  const isBooksGallllery = AppTester.isBooksGallllery()
  const { emit, token } = useAuth();
  const location = useLocation();
  const toasts = useToasts();
  const {
    t,
    i18n,
    i18n: { language },
  } = useTranslation();
  const dispatch = useDispatch();
  const modal = useSelector(modalControllerSelector);
  const modalToggle = useModal();
  const modalIsOpen = useMemo(() => !!modal.name, [modal]);
  const { hide: hideModal } = useModal();
  const isPreview = useRouteMatch<{ id: string }>([
    "/preview/:id",
    "/books/book-preview/:id",
    "/books/preview/:id",
    "/book-preview/:id",
    "/team-preview/:id",
    "/team-longread-preview/:id",
  ]);
  const isProjectPreview = useRouteMatch<{ id: string }>(["/preview/:id"]);
  const isProjectOnlyEdit = useRouteMatch<{ id: string }>(["/edit/:id"]);
  const isTeamPreview = useRouteMatch<{ id: string }>("/team-preview/:id");
  const isTeamLgPreview = useRouteMatch<{ id: string }>(
    "/team-longread-preview/:id"
  );
  const isBookChapterPreview = !!useRouteMatch([
    "/books/preview/:id",
    "/book-preview",
  ]);
  const isProjectEdit = useRouteMatch<{ id: string }>([
    "/edit/:id",
    "/books/edit/:id",
  ]);
  const isBookEdit = useRouteMatch<{ id: string }>([
    "/books/book-edit/:id",
    "/book-edit/:id",
  ]);
  const isBooksEdit = useRouteMatch<{ id: string }>("/books/edit/:id");
  const isCompetitionEdit = !!useRouteMatch<{ id: string }>(
    "/competition-edit/:id"
  );
  const isProfileEdit = useRouteMatch<{ id: string }>("/designer/edit/:id");
  const isProfilePage = useRouteMatch<{ id: string }>("/designer");
  const isTeamEdit = !!useRouteMatch("/team-edit");
  const isBrnd = AppTester.isBrnd();
  const isMedia = AppTester.isMediiia();
  const isLectureMediiia = AppTester.isLectureMediiia();
  const isProDeziiign = AppTester.isProDeziiign();
  const isCGRave = AppTester.isCGRAVE();
  const isAdcrDafesNet = AppTester.isAdcrDafesNet();
  const isFashionDeziiign = AppTester.isFashionDeziiign();
  const isGreenAward = AppTester.isGreenAward();
  const isLPU = AppTester.isLPUDesign();
  const isHseSpace = AppTester.isHseSpace();
  const isSpacePro = AppTester.isContext('s-pro');
  const isProHSE = AppTester.isProHSE();
  const id = isPreview && isPreview?.params?.id;
  const isMobile = useIsMobile();
  const isTablet = useBreakpoint(1200);
  const is744 = useBreakpoint(LayoutConst.screen.s);
  const is430bp = useBreakpoint(470);
  const is568bp = useBreakpoint(LayoutConst.screen.sm);
  const is1200 = useBreakpoint(1200);
  const [{ lang, mainBookId }, setQueryParams] = useQueryState();
  const { initialTab, context: contextName } = useContextsTabs();

  const [navProTypeValue, setNavProTypeValue] = useState<{ label: string; value: string } | null>(null);

  const isDropdownEnabled = isProDeziiign || isProHSE || isSpacePro; 
  
  const onDropdownChange = (option: { label: string; value: string } | null) => {
    if (option) {
      setNavProTypeValue(option);
      history.push(CreateLinkTo.projectCreate(), { selectedType: option.value });
    }
  };

  const mainLogo = useGetLogo({})

  const [setUserParam] = useOnlinesParam();
  const onlinesUserParam = sessionStorage.getItem("userParam");

  const [, setVisibleModalMenuCategoriesMobile] = useState<boolean>(false);
  //@ts-ignore
  const isOpen = useSelector((state) => state.openModal.isOpen);

  const closePopup = useCallback(() => {
    dispatch(setIsOpen(false));
  }, [dispatch]);

  const onMobileProjectSaveClick = () => {
    if (!primaryButtonEnabled) {
      toasts.error(t('nav.create_button.fields_required'))
      return
    }

    const onProjectSaveClick = (val: boolean) => {
      if (!!val) {
        onPrimaryClick && onPrimaryClick();
        modalToggle.hide();
        return;
      }

      modalToggle.hide();
    } 

    modalToggle.show('project-publish', {
      onClick: onProjectSaveClick
    })
  }

  const isMainBookPreview = useMemo(() => (mainBookId && isBookChapterPreview), [isBookChapterPreview, mainBookId ])

  const shouldVisibleTeamPreview = useMemo(
    () => isTeamEdit && !!previewButtonVisible,
    [isTeamEdit, previewButtonVisible]
  );

  const mobileIconState = useMemo(
    () => mobileEditorOpen ? IconStates.button : IconStates.close, [mobileEditorOpen, closeIconVisible])

  const isAgeytomesh = AppTester.isAgeytomesh();
  const isHseAnimation = AppTester.isHseAnimation();
  const isGeo = AppTester.isGeograffee();
  const isHSEDesign = AppTester.isHSEDesign();
  const isDeziiign = AppTester.isDeziiign();
  const isOnlines = AppTester.isOnlines();
  const isSchool = AppTester.isSchool();
  const isSuperPuper = AppTester.isSuperPuper();
  const isDvaDesign = AppTester.isDvaDesign();
  const isGalllleryArt = AppTester.isGalllleryArt();
  const isDamuseum = AppTester.isDaMuseum();
  const isStartHSE = AppTester.isStartHSE();
  const isContinuumSite = AppTester.isContinuumSite();
  const isKiiidsArt = AppTester.isKiiidsArt()
  const is743 = useBreakpoint(743)

  const isDafes = AppTester.isGeoDafes();
  const isBooks = !!useRouteMatch([
    LinkTo.hseBooks,
    "/hsebooks",
  ]);
  const isDesignBooks = AppTester.isBooksMain();
  const isGalllleryBooks = AppTester.isBooksGallllery();
  const isHseColors = AppTester.isHseColors();
  const isGameDeziiign = AppTester.isGameDeziiign();

  const isVisualResearch = !!useRouteMatch("/visualResearch");

  const isTagsModalActive =
    useSelector(modalControllerSelector).name === "tags";
  const isReportModalActive =
    useSelector(modalControllerSelector).name === "report";
  const isCompetitionSendProjectActive =
    useSelector(modalControllerSelector).name === "send-project";
  const isNotSavedDataModal =
    useSelector(modalControllerSelector).name === "not-saved-data";
  const isCompetitionLongreadSendProjectActive = useSelector(modalControllerSelector).name === "send-project-longread"

  const menuVisible = useMemo(
    () => (isOpen && !isNotSavedDataModal) 
  , [isOpen, isNotSavedDataModal])

  const isGeoTagModalActive = useSelector(GeoTagModalSelector)?.modalIsOpen;
  const setTheme = isSuperPuper || isCGRave || isContinuumSite || isAdcrDafesNet
    ? ApplicationTheme.black
    : isDafes
    ? ApplicationTheme.white
    : isGeo
    ? ApplicationTheme.grey
    : isGameDeziiign
    ? ApplicationTheme.additionalGreyTheme
    : isGalllleryBooks
    ? ApplicationTheme.additionalWhite_1
    : ApplicationTheme.white;

  const isDeziiignOrGeo = isDeziiign || isGeo;

  const profile = useProfile();
  const isCompetitions = location.pathname.startsWith(LinkTo.awards);
  const isModer = useMemo(
    () => profile && bProfile.isModer(profile),
    [profile]
  );
  const canViewSuperGames = useMemo(
      () => (profile && profile.rolesList && Array.isArray(profile.rolesList) && (new ProfileRole(HsePolicies.can_view_games)).containsIn(profile.rolesList)
    ), [profile]);
  const isCreateLocationPage = !!useRouteMatch(LinkTo.createLocation);
  
  const isTeamAdmin = useRouteMatch<{ id: string }>('/teamAdmin');
  const isTeacher = bProfile.isEmployee(profile);
  const isEdit = useRouteMatch<{ id: string }>("/edit/:id");
  const isTeam = !!useRouteMatch("/teams/:id");
  const isHseMain = useMemo(() => (AppTester.isContext('hsedesign')), [])
  const isDaMuseum = AppTester.isDaMuseum();
  const isProHse = AppTester.isProHSE();
  const isPro = AppTester.isProDeziiign()
  const isCreativeHSE = AppTester.isCreativeHSE();
  const isLMSHSECreative = AppTester.isLMSHSECreative();
  
  const context = getContextFromAppName(ApplicationShared.application);

  const { 
      channels, 
      loading
  } = useChannelsContext();

  const shouldVisibleFeedButton = useGetFeedInfo();

  const shouldVisibleChannelButton = useMemo(() => {
    if (loading || !profile || channels?.length === 0) return false
    return channels?.some((channel) => {
      return hasPersonalChannel(channel, profile) || hasDefaultChannel(channel,profile)
    })
  } , [channels, profile, loading])

  const isJuniorModer = useMemo(
    () => profile && profile?.rolesList?.includes("juniormoder"),
    [profile]
  );

  const { name: modalName }: ModalControllerSlice = useSelector(
    modalControllerSelector
  );

  const { teamName } = useParams<{teamName: string}>();
  const team = useExternalOrganization(teamName);

  const isTeamOwner = useMemo(
    () => {
      const tTeam = team as Team;

      if (!profile || !team) return undefined;

      return tTeam?.ownersIDs?.includes(profile?.accountId)
    } 
  , [team, profile])
  // @ts-ignore
  const isLMS = AppTester.isLMSHSE() || team?.moderationType == ModerationType.LMS;
  const isShouldVisibleLMSButton = useMemo(() => Boolean(!isTeamAdmin && (!isLMS || (team && (isTeamOwner || isModer || isTeacher)))), [isTeamAdmin, isLMS, team, isTeamOwner, isModer, isTeacher]);

  const isMobileSelectTags = useMemo(
    () =>
      modalName === "tags" &&
      (isEdit ||
        isBookEdit ||
        isCreateLocationPage ||
        isTeamEdit ||
        isBooksEdit ||
        isCompetitionEdit) &&
      isMobile,
    [
      isEdit,
      isBookEdit,
      isBooksEdit,
      isCompetitionEdit,
      isTeamEdit,
      isCreateLocationPage,
      modalName,
      isMobile,
    ]
  );
  const shouldDisplayCreateButton = useMemo(
      () => {

        if (isProjectEdit || isBookEdit || isTeamEdit || isProfileEdit || isCompetitionEdit || (isMobileSelectTags && isCreateLocationPage) || isOpen) return false;

        //@ts-ignore
        return isHSEDesign? isProHse || isDaMuseum || isHseMain || (isCompetitions && !isStartHSE) || isCreativeHSE || (!!team && !!team?.isCanCreateProject) :
        
        (((isTeam && (isModer || isTeamOwner)) || !isLMS) && !isTeamAdmin && !isLMSHSECreative &&
        ![
          "places",
          "ageytomesh",
          "education",
          'dafes',
          "dvadesign",
          "superpuper",
          "galllleryart",
        ].includes(context) &&
        !(isSuperPuper && !(isModer || isJuniorModer)))
    }
    , [isProjectEdit, isBookEdit, isTeamEdit, isProfileEdit, isCompetitionEdit, isMobileSelectTags, isCreateLocationPage, isOpen, isKiiidsArt, is743, isHSEDesign, isProHse, isDaMuseum, isHseMain, isCompetitions, isStartHSE, isCreativeHSE, team, isTeam, isModer, isTeamOwner, isLMS, isTeamAdmin, isLMSHSECreative, context, isSuperPuper, isJuniorModer]);

  const shouldDisplayContextOnNavbar = useMemo(
    () => isHSEDesign && !isProfilePage,
    [isHSEDesign, isProfilePage]
  );

  const shouldVisibleSaveBtn = useMemo(
    () => (((isProjectEdit || isBookEdit || isTeamEdit || isCompetitionEdit) && isTablet && !is744 && primaryButtonVisible) || (isProfileEdit && !is744)) && !isCompetitionLongreadSendProjectActive,
    [
      isProjectEdit, 
      isBookEdit, 
      isTeamEdit, 
      isTablet, 
      isProfileEdit, 
      is744, 
      isCompetitionLongreadSendProjectActive, 
      primaryButtonVisible, 
      isCompetitionEdit
    ]
  );
  const shouldVisibleCourseList = useMemo(
    () => isMobile && isLMS && !isTagsModalActive,
    [isMobile, isLMS, isTagsModalActive]
  );

  const PhoneButton = useMemo(() => (isHseColors && !isOpen && (
    <FlexBox offsetRight={isMobile ? 16 : 0}>
        <RectangularButtonFilled smallPadding onClick={() => navigator.clipboard.writeText('79999999999').then(() => toasts.info(t && t('phone_copied')))}>
          <PhoneText style={{color: Colors.geoWhite100}}>
            +7 999 999 99-99
          </PhoneText>
        </RectangularButtonFilled>
    </FlexBox>
  )) , [isHseColors, isMobile, toasts, t, isOpen])
  //@ts-ignore
  const isModulesLMSHSE = team?.moderationType == ModerationType.LMS || location.pathname?.includes('courses')

  const createButtonTitle = useMemo(
    () =>
        isModulesLMSHSE
        ? t("nav.create_button.create_modul") :isCompetitions
        ? t("nav.create_button.create_competition")
        : isKiiidsArt ? t('nav.create_button.add_work_kiiids') : isBooks || isDesignBooks || isGalllleryBooks
        ? t("nav.create_button.create_book") : isBrnd 
        ? t("nav.create_button.add_work"): isProDeziiign || isProHSE || isSpacePro
        ? t("nav.create_button.create_presentation")
        : t("nav.create_button.create_project"),
    [isModulesLMSHSE, t, isCompetitions, isKiiidsArt, isBooks, isDesignBooks, isGalllleryBooks, isBrnd, isProDeziiign, isProHSE]
  );

  // очередной костыль, я не понимаю почему у меня выдает ошибки при каждом изменний условий
  const isNeedTeamButtons = useMemo(
    () => isTeamEdit && !isCompetitionLongreadSendProjectActive && (secondaryButtonVisible || primaryButtonVisible)
  , [isCompetitionLongreadSendProjectActive, isTeamEdit, primaryButtonVisible])

const cardUrl = Endpoints.cardsMnePw;


const createKidsCard = useCallback(async () => {
    if (!profile) {
      return
    }
    const catalogs = await API.request()
                          .endpoint(cardUrl)
                          .url('api/Collection/GetCatalogs')
                          .get()
                          .addQuery('service', 'kids')
                          .addQuery('userId', profile?.accountId)
                          .addQuery('isUserCatalog', 'true')
                          .send()
                          .then((r: any) => r.json())
    
    const collectionId = catalogs?.[0]?.cardCollectionId


    const cardData : any = {
      "museumId": collectionId || null,
      "countryId": null,
      "artistId": profile?.accountId,
      "name": null,
      "images": null,
      "dateString": null,
      "isSelfPortrait": false,
      "isFragment": false,
      "isGameArt": false,
      "isLongreadGenerator": false,
      "isLongreadGeneratorTitle": false,
      "cardPersons": null,
      "creationCountry": null,
      "styleTime": null,
      "realMuseum": null,
      "styleLocation": null,
      "style": null,
      "objects": null,
      "userCollectionId": null,
      "mythologicalStories": null,
      "stories": null,
      "tagIds": null,
      "statusCard": 0,
      "mediaLink": "",
      "typeCard": "t_kids"
  }

    const createdCard: any = await API.Json(CardAPI.AddCard(cardData))
                              
    if (createdCard) window.open(`${process.env.REACT_APP_URL_KIIIDS_ART}/card/${createdCard}`, '_self')
  }, [cardUrl, profile])


  const isShadowModal = useMemo(
    () => SHARED_MODALS[modal?.name]?.shadowClosableBackground,
    [modal?.name]
  );
  const isActiveModal = useMemo(
    () => Boolean(modalName) && !isShadowModal,
    [modalName, isShadowModal]
  );
  const isMobileEditorOpen = useMemo(
    () => (mobileEditorOpen && isMobile && !!toggleMobileEditor) || false,
    [mobileEditorOpen, isMobile, toggleMobileEditor]
  );

  const teamsList = useMemo(() => {
    let res = [];
    for (let key in ORGANIZATION_LIST) {
      //@ts-ignore
      if (!["ageytomesh", "books"].includes(key) &&!ORGANIZATION_LIST[key].disabled
      ) {
        res.push({
          //@ts-ignore
          title: ORGANIZATION_LIST[key]?.[language === "ru" ? "titleRu" : "title"],
          name: key,
          value: `/teams/${key}`,
          ctx: "",
          active: location.pathname?.includes(key),
          external: false,
          isTeam: true,
        });
      }
    }
    return res;
  }, [location, language]);

  const urlsList = useMemo(
    () => [
      {
        title: t("nav.laboratory").toLowerCase(),
        name: "laboratory",
        value: "/teams/hselab",
        ctx: "",
        active:
          location.pathname.includes("/hselab") &&
          !location.search.includes("design"),
        external: false,
        isTeam: true,
      },
      ...teamsList,
    ],
    [location, teamsList, t]
  );


  const { onSave: onModalTagsSave, selectedTags } = useSelector(TagsSelector);

  const handleToggleMobileMenu = useCallback(
    (val: boolean) => {
      dispatch(MobileMenuStateAction.toggle(val));
      dispatch(setIsOpen(val));
    },
    [dispatch]
  );

  
  const handleModalTagSave = useCallback(() => {
    if (onModalTagsSave) onModalTagsSave(selectedTags);
    dispatch(setIsOpen(false));
    hideModal();
  } , [onModalTagsSave, hideModal, selectedTags, dispatch])

  const saveTagsMobileButtonVisible = useMemo(() => {
    if (is568bp && isGeo) return false;
    return isMobileSelectTags && !(isProHse || isPro) && is744
  } , [is568bp, isGeo, isMobileSelectTags, isProHse, isPro, is744])

  const onOnlinesLangSwitch = useCallback(
    (lang: string) => {
      // @ts-ignore
      SaveUserLang(lang);
      dispatch(setAppLang(lang));
      setQueryParams({ lang });
      i18n.changeLanguage(lang, () => window.location.reload());
    },
    [setQueryParams, dispatch, i18n]
  );

  const handleLangChange = () => {
    onLangSwitch?.();
    //todo indicate somehow that language is changed
  };

  const handleLogoClick = () => {
    if (isOnlines) {
      history.push("/");
    }
    //@ts-ignore
    isIllustration && !isTagsModalActive
      ? (window.location.href = process.env.REACT_APP_URL_HSEDESIGN_RU || "")
      : history.push(LinkTo.explore);
    //todo move everything to shared modals
    setVisibleModalMenuCategoriesMobile(false);
    handleToggleMobileMenu(false);
    hideModal();
    toggleMobileEditor && toggleMobileEditor(false);
  };

  const locationDep = location.pathname;

  useEffect(
    () => () => {
      setVisibleModalMenuCategoriesMobile(false);
      handleToggleMobileMenu(false);
      if(modal.name !== "paymentManager"){
        hideModal();
      }
    },
    [handleToggleMobileMenu, hideModal, locationDep]
  );

  useEffect(() => {
    setUserParam();
  }, [location, setUserParam]);

  useEffect(() => {
    if (isOnlines) {
      i18n.changeLanguage(lang);
    }
  }, [isOnlines, i18n, lang]);

  const theming = useMemo(
    () => ({
      zIndex: 99999,
      backgroundColor: !isGeo && !isGameDeziiign && !isCGRave
        ? theme.navigationBar.backgroundColor
        : theme.app.backgroundColor,
      borderBottomColor: theme.navigationBar.borderBottomColor,
      backgroundScrolling: theme.navigationBar.backgroundScrollingColor,
      boxShadow: theme.navigationBar.boxShadow,
      mobile: true,
    }),
    [
      isGeo,
      theme.app.backgroundColor,
      theme.navigationBar.backgroundColor,
      theme.navigationBar.backgroundScrollingColor,
      theme.navigationBar.borderBottomColor,
      theme.navigationBar.boxShadow,
    ]
  );

  const shouldDisplaySearchBar = useMemo(
    () =>
      !isMobile &&
      !isProjectEdit &&
      !isCompetitionEdit &&
      !isBookEdit &&
        (getShouldDisplaySearch()),
    [
      isMobile,
      isOnlines,
      isSchool,
      isProjectEdit,
      isCompetitionEdit,
      isBookEdit,
      isAgeytomesh,
      isHseAnimation,
      isDvaDesign,
      isGalllleryArt
    ]
  );

  const shouldDisplayLangSwitcher = useMemo(() => {
    if (isGreenAward || isLPU) {
      return null;
    }
    if (isLMS && isProjectEdit) {
      return null;
    }

    if ((isProjectEdit || isBookEdit) && !is744 && !(
      !isGreenAward && 
      !isBrnd && 
      !isSuperPuper && 
      !isLPU && 
      (isOpen || isTagsModalActive || isActiveModal) 
      && !isOnlines && 
      !isMobileSelectTags
    )) {
      return true;
    }

    if ((!isSuperPuper && !isLPU && (isOpen ||
      isTagsModalActive ||
      isActiveModal) &&
      !isGreenAward &&
      !isOnlines &&
      !isMobileSelectTags )) {
      return true;
    }

    return true;
  } , [
    isProjectEdit,
    isBookEdit,
    is744,
    isBrnd,
    isLPU,
    isOpen,
    isOnlines,
    isMobileSelectTags,
    isActiveModal,
    isTagsModalActive,
    isReportModalActive,
    isCompetitionEdit,
    isSchool,
    isGreenAward,
    isLMS,
    isSuperPuper,
    isMobile
  ])

  const onCreateClick = useCallback(() => {
   
    if (token) {
      if (isKiiidsArt) {
        createKidsCard()
        return
      }
      if (isCompetitions) {
        history.push(CreateLinkTo.competitionCreate());
      } else if (isBooks || isDesignBooks || isGalllleryBooks /*|| isVisualResearch*/) {
        history.push(CreateLinkTo.bookCreate());
      } else {
        history.push(CreateLinkTo.projectCreate());
      }
    } else {
      emit("login");
    }
  }, [token, isKiiidsArt, isCompetitions, isBooks, isDesignBooks, isGalllleryBooks, createKidsCard, history, emit]);

  const onPreviewExit = useCallback(() => {
    if (token && id) {
        isMainBookPreview 
        ? history.push(CreateLinkTo.bookEdit(mainBookId)) 
        : isBookChapterPreview
        ? history.push(CreateLinkTo.bookEdit(id))
        : isBooks
        ? history.push(CreateLinkTo.bookEdit(id))
        : isTeamPreview
        ? history.push(CreateLinkTo.teamEdit(id))
        : isTeamLgPreview
        ? history.push(CreateLinkTo.teamEdit(id) + "?tab=lg")
        : history.push(CreateLinkTo.projectEdit(id));
    }
  }, [
    token,
    id,
    isBookChapterPreview,
    isMainBookPreview,
    mainBookId,
    history,
    isBooks,
    isTeamPreview,
    isTeamLgPreview,
  ]);
  
  return (
    <ThemeProvider theme={setTheme}>
      <NavBarWrapper isKiiidsArt={isKiiidsArt}>
      <NavBar
        theming={theming}
        logo={mainLogo}
        onLogoClick={handleLogoClick}
        context={
          shouldDisplayContextOnNavbar ? t(`context_names.${contextName}`) : ""
        }
        sections={[
          [
            ...(!isOpen &&
            !isTagsModalActive &&
            !isCompetitionLongreadSendProjectActive &&
            !isMobileEditorOpen &&
            !isProjectOnlyEdit &&
            !isProjectPreview
              ? [
                  <AbsoluteWrapper centered={false} isTeamEdit>
                    {(isProjectEdit ||
                      isCompetitionEdit ||
                      isBookEdit ||
                      shouldVisibleTeamPreview) &&
                      !!onPreviewClick && (
                        <div id="preview-button" onClick={onPreviewClick}>
                          <PreviewIconOpen />
                        </div>
                      )}
                    {isPreview && !!onPreviewExit && (
                      <div id="preview-button" onClick={onPreviewExit}>
                        <IconWrapper>
                          <PreviewIconClosed />
                        </IconWrapper>
                      </div>
                    )}
                  </AbsoluteWrapper>,
                ]
              : []),
          ],
          [
            ...(isOnlines
              ? [
                  <>
                    {!isOpen && (
                      <NeutralLink to="/open-day">
                        <OpenDayButton>
                          {t("onlinesNav.btns.open_day")}
                        </OpenDayButton>
                      </NeutralLink>
                    )}
                    {(isOpen || isTagsModalActive) && isOnlines && (
                      <BLanguageSelectionComponentOnlines
                        onLangSelect={onOnlinesLangSwitch}
                        key="lang"
                      />
                    )}
                    {!isOpen && (
                      <ApplyBtn
                        lang={i18n.language}
                        href={ANCHOR_ONLINES_LINK + onlinesUserParam}
                        size={"small"}
                      >
                        {t("onlinesNav.btns.apply")}
                      </ApplyBtn>
                    )}
                  </>,
                ]
              : [
                  <RightSection>
                    {!is744 && !isOpen &&
                        !isTagsModalActive &&
                        !isMobileEditorOpen &&
                        (isProjectOnlyEdit || isProjectPreview) && (
                            <AbsoluteWrapper offsetRight={16} centered={false} isTeamEdit>
                              <MobileSaveBlock
                                  onClick={onMobileProjectSaveClick}
                                  visible={is744}/>
                              {(isProjectEdit ||
                                      isBookEdit ||
                                      isCompetitionEdit ||
                                      shouldVisibleTeamPreview) &&
                                  !!onPreviewClick && (
                                      <div id="preview-button" onClick={onPreviewClick}>
                                        <PreviewIconOpen />
                                      </div>
                                  )}
                              {isPreview && !!onPreviewExit && (
                                  <div id="preview-button" onClick={onPreviewExit}>
                                    <IconWrapper>
                                      <PreviewIconClosed />
                                    </IconWrapper>
                                  </div>
                              )}
                            </AbsoluteWrapper>
                        )}
                    {shouldDisplaySearchBar && !isOpen && (
                      <MainSearchButton />
                    )}
                    {!isPreview &&
                      !isProjectEdit &&
                      !isBookEdit &&
                      !isCompetitionEdit &&
                      !isTeamEdit &&
                      !isActiveModal &&
                      !isOpen && (
                        <>
                          {!isDvaDesign && !isAgeytomesh && (
                            <>
                              <NotificationsController/>
                              {shouldVisibleChannelButton && <ChannelButton />}
                              {shouldVisibleFeedButton && <FeedButton />}
                            </>
                          )}
                          <TeamInfo />
                        </>
                      )}
                    {(isModer || canViewSuperGames) && isMedia && !isLectureMediiia &&  <GameButton />}
                    {shouldDisplayLangSwitcher && (
                        <LangSwitcherWrapper
                          isOpen={isOpen} 
                          isKiiidsArt={isKiiidsArt}
                          offsetRight={isSuperPuper ? 6 : 16}
                          offsetLeft={16}
                        >
                          <BLangSwitcher
                            currentLanguage={i18n.language}
                            onLangSelect={handleLangChange}
                            key="lang"
                            mobile
                            activeBg={isKiiidsArt ? '#94209E' : ''}
                            itemStyle={isKiiidsArt ? 'border-radius: 8px;' : ''}
                          />
                        </LangSwitcherWrapper>
                      )}
                    {PhoneButton}
                    {                   
                      isCompetitions 
                        ? 
                          isSchool
                        : 
                          (isSchool &&
                          !isShouldVisibleLMSButton)?
                          <></> :
                          shouldDisplayCreateButton && !isGreenAward && !is430bp && !modalName ?
                          (
                            <DropdownWrapper key="mobile-create-dropdown">
                            {isDropdownEnabled ? (
                              <ProjectEditPageGridInput isColumns>
                                <CustomDropdown
                                lang={i18n.language}
                                value={navProTypeValue}
                                onChange={onDropdownChange}
                                onMenuOpen={() => {
                                  dispatch(NavbarSearchActions.setNavbarSearchToggle({ data: false }));
                                  document.body.click();
                                }}
                                options={proTypeOptions}
                                placeholder={createButtonTitle ?? "Выбрать тип"}
                                
                              />
                              </ProjectEditPageGridInput>
                              
                            ) : (
                              <CreateButton style={isGreenAward ? { marginLeft: '10px' } : {}} onClick={onCreateClick} isKiiids={isKiiidsArt} isMedia={isMedia}>
                                {createButtonTitle}
                              </CreateButton>
                            )}
                          </DropdownWrapper>
                      ): <></>
                    }
                    {false &&
                      isProfileEdit &&
                      !!onPrimaryClick &&
                      !!onSecondaryClick &&
                      !isOpen && (
                        <FlexBox>
                          <RectangularButtonFilled
                            style={{
                              minWidth: "77px",
                              maxWidth: "77px",
                              marginRight: "10px",
                            }}
                            onClick={onPrimaryClick}
                          >
                            {primaryButtonText}
                          </RectangularButtonFilled>
                          <RectangularButtonHollow
                            style={{ minWidth: "77px", maxWidth: "77px" }}
                            onClick={onSecondaryClick}
                          >
                            {secondaryButtonText}
                          </RectangularButtonHollow>
                        </FlexBox>
                      )}
                    {shouldVisibleCourseList && <CourseInfoListController />}
                    {is744 && !isOpen &&
                      !isTagsModalActive &&
                      !isMobileEditorOpen &&
                      (isProjectOnlyEdit || isProjectPreview) && (
                        <AbsoluteWrapper offsetRight={16} centered={false} isTeamEdit>
                          {!(isLMS && isProjectEdit) && (
                            <MobileSaveBlock
                              onClick={onMobileProjectSaveClick}
                              visible={is744}/>
                          )}
                          {(isProjectEdit ||
                            isBookEdit ||
                            isCompetitionEdit ||
                            shouldVisibleTeamPreview) &&
                            !!onPreviewClick && (
                              <div id="preview-button" onClick={onPreviewClick}>
                                <PreviewIconOpen />
                              </div>
                            )}
                          {isPreview && !!onPreviewExit && (
                            <div id="preview-button" onClick={onPreviewExit}>
                              <IconWrapper>
                                <PreviewIconClosed />
                              </IconWrapper>
                            </div>
                          )}
                        </AbsoluteWrapper>
                      )}
                    {is744 &&
                      (!!onSecondaryClick || isPreview) &&
                      !isProfileEdit &&
                      !isTeamEdit &&
                      !isOpen &&
                      !isMobileSelectTags &&
                      (isProjectOnlyEdit || isProjectPreview || isBookEdit || isBookChapterPreview || isBooksGallllery) && (
                        <AgreeButtonWrapper
                          disabled={!canSaveLgText}
                          isPreview={!!isPreview}
                          onClick={
                              isPreview
                              ? () => history.push(CreateLinkTo.explore())
                              : onSecondaryClick
                          }
                          {...theme.navigationBar.login}
                        >
                          <AgreeOrClose type={mobileIconState} enabled={true} />
                        </AgreeButtonWrapper>
                      )}
                    {is568bp &&
                      (!!onSecondaryClick || isPreview) &&
                      !isProfileEdit &&
                      !isTeamEdit &&
                      !isBookEdit &&
                      !isBookChapterPreview &&
                      !isOpen &&
                      !isMobileSelectTags &&
                      !isProjectOnlyEdit &&
                      !isProjectPreview && (
                        <ProjectSaveButton
                          disabled={!canSaveInDrafts || !previewButtonEnabled}
                          fixedSize
                          style={{ marginRight: "11px" }}
                          onClick={
                            isPreview
                              ? () => history.push(CreateLinkTo.explore())
                              : onSecondaryClick
                          }
                          {...theme.navigationBar.login}
                        >
                          {t("project_edit.save")}
                        </ProjectSaveButton>
                      )}
                    {shouldVisibleSaveBtn &&
                      !isMobileSelectTags &&
                      !isOpen && (
                        <ProjectSaveButton
                          disabled={!primaryButtonEnabled}
                          onClick={onPrimaryClick}
                        >
                          {isTeamEdit
                            ? primaryButtonText
                            : t("project_edit.save")}
                        </ProjectSaveButton>
                      )}

                    {/*КНОПКИ ДЛЯ РЕДАКТИРОВАНИЯ  ОРГАНИЗАЦИЙ В МОДЕРКЕ*/}
                    {isNeedTeamButtons &&
                      is568bp &&
                        !isMobileSelectTags &&
                      !isOpen && (
                        <ExitButton isTeamEdit onClick={onSecondaryClick}>
                          {secondaryButtonText}
                        </ExitButton>
                    )}
                    {isNeedTeamButtons &&
                      is568bp &&
                      !isMobileSelectTags &&
                      !isOpen && (
                        <ProjectSaveButton
                          style={{ marginLeft: 8 }}
                          fixedSize
                          disabled={!primaryButtonEnabled}
                          onClick={onPrimaryClick}
                        >
                          {primaryButtonText}
                        </ProjectSaveButton>
                      )}

                    {saveTagsMobileButtonVisible && (
                      <SaveButton
                        onClick={handleModalTagSave}
                      >
                        {t("project_edit.save")}
                      </SaveButton>
                    )}
                    {!isCompetitionLongreadSendProjectActive && !is744 &&
                      (isProjectEdit || isBookEdit || isTeamEdit || isCompetitionEdit || (isProfileEdit && !is744)) &&
                      !isMobileSelectTags &&
                      !isPreview &&
                      !isMobileEditorOpen &&
                      !isGeoTagModalActive &&
                      !isOpen &&
                      secondaryButtonVisible && (
                        <ExitButton
                          style={{ ...(isProfileEdit && {marginRight: 16} )}}
                          fixedSize
                          onClick={() =>
                            (isBookEdit || isTeamEdit || isBooksEdit || isProfileEdit || isProjectEdit || isCompetitionEdit) &&
                            onSecondaryClick
                              ? onSecondaryClick()
                              : history.push(CreateLinkTo.explore())
                          }
                        >
                          {isTeamEdit
                            ? secondaryButtonText
                            : t("nav.exit_other") ?? "Exit"}
                        </ExitButton>
                      )}
                    
                    {!isProjectEdit &&
                      !isTeamEdit &&
                      !isBookEdit &&
                      !isCompetitionEdit &&
                      !isPreview &&
                      !isOpen &&
                      !isTagsModalActive &&
                      !isActiveModal && <WidgetLogin />}
                    {!isSuperPuper && !isLPU && (isOpen ||
                      isTagsModalActive ||
                      isActiveModal) &&
                      !isGreenAward &&
                      !isOnlines &&
                      !isMobileSelectTags && (
                        <>
                        <WidgetLogin /> 
                        </>
                      )}
                  </RightSection>,
                ]),
          ],
        ]}
      />

      <ModalMenuContextMobileNew
        hseUrls={urlsList}
        visible={menuVisible}
        closeMenu={closePopup}
      />

      <MobileBottomBar
        primaryButtonData={{
          onClick: onPrimaryClick,
          enabled: primaryButtonEnabled,
          text: primaryButtonText,
        }}
        onSave={handleModalTagSave}
        isMobileEditorOpen={isMobileEditorOpen}
      />
      </NavBarWrapper>
    </ThemeProvider>
  );
};

export default DeziignNavBarMobile;
